import {useState} from 'react'
import {creditCard, creditCardResponse} from '../../../../core/_models'
import {useFormik} from 'formik'
import Cards from 'react-credit-cards-2'
import Swal from 'sweetalert2'
import {cpfMask} from '../../../../../../utils/cpfMask'
import {formatDateCrediCard} from '../../../../../sales/payment/utils/mask'
import {creditCardSchema} from '../../core/Validation/CreditCardVali'
import {buildCreditCardRequest} from '../../core/Validation/biuldRequestCart'
import {
  changeCreditCard,
  createCreditCard,
  getCreditCards,
  updateCreditCard,
} from '../../core/_requests'

interface ICreditCardInfo {
  creditCard?: creditCardResponse
  franchiseId: number
  onClose: () => void
  setDataCreditCards: React.Dispatch<React.SetStateAction<creditCardResponse[]>>
  setLoadingCredtCardContentProgress: React.Dispatch<React.SetStateAction<boolean>>
}

const CardsModal = ({
  franchiseId,
  creditCard,
  onClose,
  setDataCreditCards,
  setLoadingCredtCardContentProgress,
}: ICreditCardInfo) => {
  const [hideIsFavoriteRadio, setHideIsFavoriteRadio] = useState<boolean>(
    creditCard?.isFavorite ? true : false || false
  )

  const defaultCreditCardData = {
    holder: creditCard?.holderName?.toString() || '',
    document: creditCard?.holderDocument?.toString() || '',
    number: `${creditCard?.firstNumbers ?? ''}********${creditCard?.lastNumbers ?? ''}` || '',

    month:
      `${creditCard?.expirationMonth?.toString()}/${creditCard?.expirationYear
        ?.toString()
        .slice(2, 4)}` || '',
    year: creditCard?.expirationYear?.toString() || '',
    cvv: '***',
    isFavorite: 0,
  }

  const [formData, setFormData] = useState<creditCard>(defaultCreditCardData)

  function handleSubmit(event) {
    event.preventDefault()
    formik.handleSubmit()
  }

  const handlePaste = (evt) => {
    evt.preventDefault()
    const {name} = evt.target

    const pastedText = evt.clipboardData.getData('Text')

    const formatedValue = pastedText.replace(/\D/g, '')

    setFormData({...formData, [name]: formatedValue.slice(0, 16)})
    formik.setFieldValue(name, formatedValue.slice(0, 16))
  }

  const handleInputCardChange = (evt) => {
    const {name, value} = evt.target

    if (name == 'number') {
      const valCardFormat = value.replace(/\D/g, '')
      setFormData({...formData, [name]: valCardFormat.slice(0, 16)})
      formik.setFieldValue(name, valCardFormat)
      return
    }

    if (name == 'document') {
      const valCardFormat = value.replace(/\D/g, '')
      setFormData({...formData, [name]: cpfMask(valCardFormat.slice(0, 11))})
      formik.setFieldValue(name, valCardFormat)
      return
    }

    if (name == 'isFavorite') {
      setHideIsFavoriteRadio(!hideIsFavoriteRadio)

      const valCardFormat = !hideIsFavoriteRadio ? 1 : 0

      setFormData({...formData, [name]: valCardFormat})
      formik.setFieldValue(name, valCardFormat)
      return
    }

    setFormData({...formData, [name]: value})
    formik.setFieldValue(name, value)
  }

  const formik = useFormik({
    initialValues: defaultCreditCardData,
    validationSchema: creditCardSchema,
    validateOnChange: true,
    validateOnMount: true,
    onSubmit: async () => {
      try {
        const requestData = buildCreditCardRequest(formData)
        if (creditCard) {
          await updateCreditCard(franchiseId, creditCard.id)
        } else {
          await createCreditCard(franchiseId, requestData)
        }

        setLoadingCredtCardContentProgress(true)

        const cards = await getCreditCards(franchiseId)

        setDataCreditCards(cards)

        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: creditCard ? 'Cartão atualizado com sucesso!!' : 'Cartão cadastrado com sucesso!!',
          allowOutsideClick: false,
          timer: 5000,
        })

        onClose()
      } catch (error: any) {
        Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text:
            error.response.data.message ??
            (creditCard
              ? 'Ocorreu um erro ao atualizar o cartão.'
              : 'Ocorreu um erro ao cadastrar o cartão'),
          showConfirmButton: true,
          allowOutsideClick: false,
          customClass: {
            confirmButton: 'btn btn-danger',
            cancelButton: 'btn btn-secondary',
          },
        })
      } finally {
        setLoadingCredtCardContentProgress(false)
      }
    },
  })

  return (
    <>
      <div className='modal fade show d-block' tabIndex={-1}>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Dados do cartão</h5>

              <button type='button' className='btn-close' onClick={onClose} />
            </div>

            <div className='modal-body'>
              <form
                id='data-kt-users-modal-action'
                className='form'
                onSubmit={handleSubmit}
                noValidate
              >
                <div className='row'>
                  <div className='col-lg-12 text-start'>
                    <div className='d-flex justify-content-center mb-5'>
                      <Cards
                        number={formData.number}
                        expiry={formData.month}
                        cvc={formData.cvv}
                        name={formData.holder || ' '}
                        locale={{
                          valid: 'VÁLIDO ATÉ',
                        }}
                      />
                    </div>
                    {!creditCard && (
                      <>
                        <div className='position-relative mb-5'>
                          <label className='d-flex align-items-center fs-6 mt-4 fw-bold form-label mb-2'>
                            <span className='required'>Número do Cartão</span>
                            <i
                              className='fas fa-exclamation-circle ms-2 fs-7'
                              data-bs-toggle='tooltip'
                              title='Número do cartão'
                            ></i>
                          </label>
                          <input
                            type='text'
                            name='number'
                            maxLength={16}
                            value={formData.number}
                            className='form-control form-control-solid'
                            onChange={handleInputCardChange}
                            onPaste={handlePaste}
                          />
                          {<small className='text-danger'>{formik.errors.number}</small>}
                        </div>
                        <div className='d-flex flex-column mb-5 fv-row'>
                          <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                            <span className='required'>Nome impresso no cartão</span>
                            <i
                              className='fas fa-exclamation-circle ms-2 fs-7'
                              data-bs-toggle='tooltip'
                              title='Nome impresso no cartão'
                            ></i>
                          </label>
                          <input
                            type='text'
                            className='form-control form-control-solid'
                            name='holder'
                            placeholder='Nome impresso no cartão'
                            value={formData.holder}
                            onChange={handleInputCardChange}
                          />
                          {<small className='text-danger'>{formik.errors.holder}</small>}
                        </div>
                        <div className='mb-5'>
                          <div className='row'>
                            <div className='mb-5 col-lg-8'>
                              <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                                <span className='required'>Válido até</span>
                                <i
                                  className='fas fa-exclamation-circle ms-2 fs-7'
                                  data-bs-toggle='tooltip'
                                  title='Validade'
                                ></i>
                              </label>
                              <input
                                type='text'
                                maxLength={5}
                                name='month'
                                className='form-control form-control-solid'
                                placeholder='**/**'
                                value={formatDateCrediCard(formData.month)}
                                onChange={handleInputCardChange}
                              />
                              {<small className='text-danger'>{formik.errors.month}</small>}
                            </div>
                            <div className='col-lg-4'>
                              <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                                <span className='required'>CVV</span>
                                <i
                                  className='fas fa-exclamation-circle ms-2 fs-7'
                                  data-bs-toggle='tooltip'
                                  title='Valor de Verificação do Cartão'
                                ></i>
                              </label>
                              <input
                                type='number'
                                name='cvv'
                                placeholder='***'
                                className='form-control form-control-solid'
                                onChange={handleInputCardChange}
                              />
                              {<small className='text-danger'>{formik.errors.cvv}</small>}
                            </div>
                          </div>
                        </div>
                        <div className='d-flex flex-column mb-5 fv-row'>
                          <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                            <span className='required'>CPF</span>
                            <i
                              className='fas fa-exclamation-circle ms-2 fs-7'
                              data-bs-toggle='tooltip'
                              title='Informe o CPF'
                            ></i>
                          </label>
                          <input
                            type='text'
                            className='form-control form-control-solid'
                            name='document'
                            placeholder='CPF'
                            value={formData.document}
                            onChange={handleInputCardChange}
                          />
                          {<small className='text-danger'>{formik.errors.document}</small>}
                        </div>
                      </>
                    )}
                    <div className='d-flex flex-column mb-5 fv-row'>
                      <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                        <span className='required'>Cartão Principal?</span>
                        <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Defina este cartão como principal para que ele seja utilizado automaticamente nas suas compras e pagamentos recorrentes.'
                        ></i>
                      </label>
                      <div className='form-check form-switch form-check-custom form-check-solid'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          name='isFavorite'
                          checked={hideIsFavoriteRadio}
                          onChange={handleInputCardChange}
                        />
                      </div>
                      {<small className='text-danger'>{formik.errors.isFavorite}</small>}
                    </div>
                  </div>
                </div>
                <div className='modal-footer'>
                  <button
                    type='submit'
                    className='btn btn-danger btn-lg w-100'
                    data-kt-users-modal-action='submit'
                    disabled={!formik.isValid || formik.isSubmitting}
                    data-kt-indicator={formik.isSubmitting ? 'on' : 'off'}
                  >
                    <span className='indicator-label'>
                      {creditCard ? 'Alterar cartão' : 'Adicionar cartão'}
                    </span>
                    {formik.isSubmitting && (
                      <span className='indicator-progress'>
                        Aguarde...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export {CardsModal}
